import React, { useCallback } from 'react';

import { Terms, SpanLink } from '../../styledComponent/SignUpComponents.style';
import { isMobileAppWebView } from '../../../utils/utilsFunctions';

interface TermsAndConditionsProps {
  setIsTermsPopUpOpen: (value: boolean) => void;
  id: string;
}

export const TermsAndConditions = ({ setIsTermsPopUpOpen, id }: TermsAndConditionsProps) => {
  const openTerms = useCallback(() => {
    if (!isMobileAppWebView) {
      window.open(`${process.env.REACT_APP_WEBSITE}/terms-of-use/`, '_blank');
      return;
    }

    setIsTermsPopUpOpen(true);
  }, [setIsTermsPopUpOpen]);
  const openPrivacy = useCallback(() => {
    if (!isMobileAppWebView) {
      window.open(`${process.env.REACT_APP_WEBSITE}/privacy/`, '_blank');
      return;
    }

    setIsTermsPopUpOpen(true);
  }, [setIsTermsPopUpOpen]);

  return (
    <Terms>
      By continuing, you agree to the Circles <SpanLink onClick={openTerms}>terms of use</SpanLink> and <SpanLink onClick={openPrivacy}>privacy policy</SpanLink>
    </Terms>
  );
};
